


































































import Vue from "vue";
import Component from "vue-class-component";
import {State} from "vuex-class";
import Category from "@/modules/support/model/Category";
import Loader from "@/components/Loader.vue";
import {notify} from "@/modules/core/notification";
import CategoryTree from "@/modules/support/components/Guide/CategoryTree.vue";

@Component({
    components: {
        CategoryTree,
        Loader
    }
})
export default class CategoryMasterDetail extends Vue {
    /**
     * Categoría actualmente seleccionada por el usuario
     */
    @State(state => state.support.currentCategory)
    currentCategory: Category | null

    public loading = true
    public saving = false

    /**
     * Actualiza un campo de la categoría actualmente seleccionada por el usuario
     *
     * @param field
     * @param value
     */
    public updateField(field: string, value: any) {
        this.$store.commit('support/UPDATE_CATEGORY_FIELD', {field, value})
    }

    /**
     * Cancelar edición
     */
    public cancelEdit () {
        if (this.currentCategory && this.currentCategory.isNew) {
            this.$store.commit('support/REMOVE_CATEGORY', 0)
        }

        this.$store.commit('support/SET_CURRENT_CATEGORY', null)
    }

    /**
     * Actualiza la información de la categoría en el servidor
     */
    public async save() {
        this.saving = true
        await this.$store.dispatch('support/saveCategory')

        notify(`La categoría ${this.currentCategory?.name} ha sido actualizada`)
        this.saving = false
    }

    async created() {
        await this.$store.dispatch('support/loadRootCategory')
        this.loading = false
    }
}
